<template>
  <computed-status-badge :status-list="allTransactionStatus" :value="value" />
</template>

<script>

import {LocaleUtils} from '@/utils/locale-utils';
import ComputedStatusBadge from '@/components/ComputedStatusBadge';
import {TransactionStatus as TransactionStatusEnum} from '@/lib/transaction-status';

export default {
  name: 'TransactionStatus',
  components: {ComputedStatusBadge},
  mixins: [
    LocaleUtils
  ],
  props: ['value'],
  computed: {
    allTransactionStatus () {
      return [
        {
          value: TransactionStatusEnum.WAITING_FOR_DOWNLOAD,
          text: this.trans('transaction.statusWaitingForDownload'),
          color: 'pending'
        },
        {
          value: TransactionStatusEnum.WAITING_FOR_EMAIL,
          text: this.trans('transaction.statusWaitingForEmail'),
          color: 'pending'
        },
        {
          value: 'EMAIL_PENDING',
          text: this.trans('transaction.statusEmailPending'),
          color: 'gray'
        },
        {
          value: TransactionStatusEnum.WAITING_FOR_PAYBACK,
          text: this.trans('transaction.statusWaitingForPayback'),
          color: 'pending'
        },
        {
          value: TransactionStatusEnum.DONE,
          text: this.trans('transaction.statusDone'),
          color: 'success'
        },
      ]
    },
  },
}
</script>
